import { MercEnvService } from '@aipb/gulliver/merc/env';
import { BaseRouting } from '@aipb/gulliver/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MercRouting extends BaseRouting {
  static APP_ROUTE = 'merc';

  static configPath = ':configId';

  constructor(mercEnv: MercEnvService) {
    super(['/' + MercRouting.APP_ROUTE, MercRouting.configPath], mercEnv);
  }
}
